import * as e from "react";
const a = (l) => /* @__PURE__ */ e.createElement(
  "svg",
  {
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ...l
  },
  /* @__PURE__ */ e.createElement(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M6.998 6h12.385l-3.498 7H6.997V6zM3.636 17.852a3 3 0 011.363-4.682V4h-2a1 1 0 010-2h3a1 1 0 011 1v1h13.994a1 1 0 01.9 1.45l-3.777 7.557a.997.997 0 01.878.993 1 1 0 01-1 1H6a1 1 0 000 2h11.995a1 1 0 010 2h-.27a1.995 1.995 0 01.005 2 1.999 1.999 0 11-3.463-2H8.728a2 2 0 01-3.065 2.488 1.996 1.996 0 01-.354-2.568 3.01 3.01 0 01-1.673-1.068z",
      fill: "#2d6ded"
    }
  )
), t = a;
export {
  t as default
};
